export default __webpack_public_path__ + "static/card-6-7b63e542c7f1ed742d911ab1e3dcdbd1.png";